import { getWindow } from '@/shared/lib/getWindow';
import { collect } from './api/api';

export interface EcomProduct {
    id: string;
    name: string;
    brand: string;
    price?: string;
    category?: string;
}

export const trackEcomEvent = (
    event: string,
    metricClientId: string,
    yaCounter: number,
    storeSlug: string,
    params: { title?: string; eventName: string; products?: EcomProduct[] }
) => {
    const query = new URLSearchParams({
        t: event === 'pageview' ? 'pageview' : 'event',
        tid: yaCounter.toString(),
        cid: metricClientId,
    });
    const href = getWindow()?.location.href;

    if (event === 'pageview') {
        const referrer = getWindow()?.document.referrer;

        if (referrer) {
            query.append('dr', referrer);
        }

        if (href) {
            query.append('dl', href);
        }

        if (params?.title) {
            query.append('dt', params.title);
        }
    }

    if (event === 'ecom') {
        query.append('pa', params.eventName);
        (params.products || []).forEach((product, index) => {
            query.append(`pr${index + 1}id`, `${index + 1}`);
            query.append(`pr${index + 1}nm`, product.name);

            if (product.brand) {
                query.append(`pr${index + 1}br`, product.brand);
            }

            if (product.price) {
                query.append(`pr${index + 1}pr`, product.price);
            }

            if (product.category) {
                query.append(`pr${index + 1}ca`, product.category);
            }
        });
    }

    return collect({
        store_slug: storeSlug,
        query: query.toString(),
    });
};
